import { Button, Flex } from "antd"
import { DayOfWeek } from "../../../domain/proposals/settings/proposalSettings"

type Props = {
  value: DayOfWeek
  disabled?: boolean
  onChange: (value: DayOfWeek) => void
}

const DayOfWeekSelector = ({value, disabled, onChange}: Props) => {
  return <Flex gap={4}>
    {weekdayOptions.map((option, index) => <Button
      key={`weekday-${index}`}
      type={value === option.value ? 'primary' : 'default'}
      onClick={() => onChange(option.value as DayOfWeek)}
      disabled={disabled}
      style={{borderRadius: '16px'}}
    >
      {option.label}
    </Button>)}
  </Flex>
}

export default DayOfWeekSelector

const weekdayOptions = [
  { label: 'S', value: 'Sunday' },
  { label: 'M', value: 'Monday' },
  { label: 'T', value: 'Tuesday' },
  { label: 'W', value: 'Wednesday' },
  { label: 'T', value: 'Thursday' },
  { label: 'F', value: 'Friday' },
  { label: 'S', value: 'Saturday' },
]